export const differenceInDays = (dateA: number, dateB: number): number => {
  return Math.round((dateA - dateB) / (1000 * 60 * 60 * 24));
};
